import React, { useEffect } from "react"
import { CardBody } from "../../../../../_metronic/_partials/controls/index.js"
import { linkWithCtrl } from "../../../../helpers/Utils.js"
import TableView, { formatterRowComponent } from "../../../../../component/atoms/Tabel/index.jsx"
import { Card, OverlayTrigger, Tooltip } from "react-bootstrap"
import { DetailSvgIcon, EditSvgIcon } from "../../../../../component/atoms/Icons/SVG/index.jsx"
import { sortCaret } from "../../../../../_metronic/_helpers/index.js"
import { loadUserLogin } from "../../../../service/userManagementAction.js"
import { RoutesConstants } from "../../../../../constants/RoutesConstants.js"
import { EmptyCard, TableSkeleton } from "../../../../../component/index.jsx"
import { useLocation } from "react-router"
import { useSubheader } from "../../../../../_metronic/layout/index.js"
import { getUrlParsingPageFilter } from "../../../../../config/EndpointCollection.js"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { ILLUSTRATION_CONSTANTS } from "../../../../../constants/ImageConstants.js"
import { ROUTING_STATUS } from "../../../../../constants/StringConstant.js"
import { PRIVILEGE_ENUM } from "../../../../../constants/PrivilegeConstants.js"

export function Table({ data, changePage, history, general, initialFilterTable, isFilter }) {
  const privileges = loadUserLogin().privilege
  const location = useLocation()
  const subheader = useSubheader()
  const { t } = useTranslation()
  const { General } = useSelector((state) => state)

  useEffect(() => {
    subheader.setButton(undefined)
  }, [])

  const columns = [
    {
      dataField: "code",
      text: "ID MITRA",
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiCode
      },
      sortCaret: sortCaret
    },
    {
      dataField: "name",
      text: "NAMA",
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiName
      },
      sortCaret: sortCaret,
      sort: true,
      onSort: (field, order) => {
        let param = getUrlParsingPageFilter({
          ...initialFilterTable,
          sort: field + "," + order
        })
        history.push({ pathname: location.pathname, search: param })
      }
    },
    {
      dataField: "address",
      text: "ALAMAT",
      formatter: formatterRowComponent,
      sortCaret: sortCaret,
      formatExtraData: {
        externalStyle: uiAddress
      },
      headerStyle: () => {
        return { width: "25%" }
      }
    },

    {
      dataField: "action",
      text: "Actions",
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiAction
      }
    }
  ]

  function uiAddress(e) {
    return <>{e?.address ? e?.address : "-"}</>
  }

  function uiName(e) {
    return (
      <>
        <a className="text-dark font-weight-bolder mb-1 font-size-lg">{e.name}</a>
        {privileges.indexOf(PRIVILEGE_ENUM.MITRA_PHONE_NUMBER) > -1 && (
          <span className="text-muted font-weight-bold d-block">{e.phone}</span>
        )}
      </>
    )
  }

  function uiCode(e) {
    return (
      <>
        <a className="text-dark font-weight-bolder mb-1 font-size-lg">{e.code}</a>
      </>
    )
  }

  function uiAction(e) {
    return (
      <>
        {privileges.indexOf(PRIVILEGE_ENUM.DETAIL_MITRA_REGISTERED) > -1 && (
          <OverlayTrigger overlay={<Tooltip id="products-edit-tooltip">Detail</Tooltip>}>
            <div
              className="btn btn-icon btn-detail btn-hover-secondary btn-sm mx-3"
              onClick={() =>
                history.push(
                  RoutesConstants.MITRA.DETAIL_MITRA(
                    ROUTING_STATUS.STATUS_STRING.ACTIVE,
                    e?.id_mitra
                  )
                )
              }>
              <DetailSvgIcon />
            </div>
          </OverlayTrigger>
        )}
        {privileges.indexOf(PRIVILEGE_ENUM.UPDATE_MITRA) > -1 && (
          <OverlayTrigger overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}>
            <div
              className="btn btn-icon btn-detail btn-hover-secondary btn-sm mx-3"
              onClick={() => history.push(RoutesConstants.MITRA.EDIT_MITRA("active", e.id_mitra))}>
              <EditSvgIcon />
            </div>
          </OverlayTrigger>
        )}
      </>
    )
  }

  return (
    <>
      <Card className="card-shadowless">
        <CardBody>
          {General.loading ? (
            <TableSkeleton column={5} row={10} />
          ) : data?.pageData?.length == 0 ? (
            <EmptyCard
              subtitle={isFilter ? t("messages_response_empty_search_subtitle") : ""}
              image={
                isFilter
                  ? ILLUSTRATION_CONSTANTS.EMPTY_STATE_NO_DATA
                  : ILLUSTRATION_CONSTANTS.EMPTY_STATE
              }
              body={
                isFilter
                  ? t("messages_response_searching_not_found")
                  : t("messages_response_empty_state", { name: "mitra ca" })
              }
            />
          ) : (
            ""
          )}
          <TableView
            callbackAfterPageChange={changePage}
            columnProperties={columns}
            dataTable={data?.pageData ?? []}
            currentPage={data?.page?.currentPage ?? 1}
            currentElement={data?.page?.currentElement ?? 10}
            totalCount={data?.page?.totalCount ?? 0}
            loadingGetData={general.loading}
            ignoreSinglePage
            rowClasses={() => {
              return "cursor-pointer"
            }}
            rowEvents={{
              onClick: (e, row) => {
                if (privileges.indexOf(PRIVILEGE_ENUM.DETAIL_MITRA_REGISTERED) > -1) {
                  if (e.target.cellIndex < 4) {
                    const url = RoutesConstants.MITRA.DETAIL_MITRA(
                      ROUTING_STATUS.STATUS_STRING.ACTIVE,
                      row?.id_mitra
                    )
                    if (e.ctrlKey) {
                      linkWithCtrl(url)
                    } else {
                      history.push(url)
                    }
                  }
                }
              }
            }}
          />
        </CardBody>
      </Card>
    </>
  )
}
